export default "/images/vendor/flag-icon-css/flags/4x3/ci.svg?b1030b2b5315547c7fbe93c5dc5e8f78";